<div class="media-upload-card">

  <div class="warning-banner">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <span>Do not close this browser or lock your phone while uploads are in progress</span>
  </div>

  <h2 class="upload-title">Uploading Media</h2>
  <p class="upload-subtitle">The inspection is complete. Please keep this page open while we upload the remaining files.
  </p>

  <div class="eta-row" *ngIf="estimatedTimeRemaining">
    <span class="eta-label">Estimated time remaining</span>
    <span class="eta-value">{{ estimatedTimeRemaining }}</span>
  </div>

  <div class="file-list-card">
    <h4 class="file-list-heading">Uploading Files</h4>

    <div class="file-row" *ngFor="let file of pendingUploadFiles" [hidden]="file.status === null">
      <div class="file-icon" [ngClass]="getFileIconClass(file.fileName)">
        <ion-icon [name]="getFileIcon(file.fileName)"></ion-icon>
      </div>
      <span class="file-name">{{ file.fileName }}</span>
      <!-- <div class="file-status">
        <ion-spinner *ngIf="file.status === 'Uploading'" name="crescent" class="status-spinner"></ion-spinner>
        <ion-icon *ngIf="file.status === 'Failed'" name="close-circle" class="status-failed"></ion-icon>
      </div> -->
      <div class="file-status">
        <ion-spinner *ngIf="file.status === 'Uploading'" name="crescent" class="status-spinner"></ion-spinner>
        <ion-icon *ngIf="file.status === 'Uploaded'" name="checkmark-circle" class="status-check"></ion-icon>
        <ion-icon *ngIf="file.status === 'Failed'" name="close-circle" class="status-failed"></ion-icon>
        <!-- 'Queued' shows no icon, matching a subtle "waiting its turn" look -->
      </div>
    </div>
  </div>

  <div class="failed-actions" *ngIf="hasFailedFiles()">
    <p class="warn-text">Some files couldn't upload after several attempts.</p>
    <ion-button size="small" (click)="retryFailedUploads()">Retry Failed</ion-button>
  </div>

</div>